import {
  type Dispatch,
  type SetStateAction,
  useRef,
  useState,
  type RefObject,
} from 'react';

/**
 * Hook for having a state combined with a ref object
 * @internal
 */
export function useReferencedState<S>(
  initialState: S | (() => S),
): [S, Dispatch<SetStateAction<S>>, RefObject<S | null>] {
  const [state, setState] = useState(initialState);
  const stateRef = useRef<S | null>(null);
  stateRef.current = state;
  return [state, setState, stateRef];
}
